<template>
  <v-dialog v-model="dialog" width="60%" persistent>
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text">
          Logs
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="info"
          :items-per-page="5"
          :loading="loading"
          class=" elevation-1 rounded-lg"
          :footer-props="{ itemsPerPageText: 'Linhas por página' }"
        >
          <template v-slot:[`item.nome`]="{ item }">
            {{ checkData(item.nome) | TitleCase }}
          </template>
          <template v-slot:[`item.nome`]="{ item }">
            {{ checkData(item.nome) | TitleCase }}
          </template>
          <template v-slot:[`item.data_log`]="{ item }">
            {{ item.data_log | BrazilianStandardDateAndTime }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import dateMixin from "@/mixins/dateMixin";
import descontos from "@/services/http/descontos/Descontos.js";
export default {
  mixins: [dateMixin],

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    schema: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loading: false,
      info: [],
      headers: [
        {
          text: "Schema",
          value: "schema",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "Usuário",
          value: "usuario",
          align: "center",
        },
        {
          text: "Nome",
          value: "nome",
          align: "center",
        },
        {
          text: "Data",
          value: "data_log",
          align: "center",
        },
      ],
    };
  },

  watch: {
    dialog(value) {
      if (value) {
        this.fetchLogs(this.schema);
      }
    },
  },

  methods: {
    async fetchLogs(schema) {
      try {
        this.loading = true;
        let { data } = await descontos().logsShow({
          schema,
          per_page: 5,
          "orderBy[desc]": "data_log",
        });
        this.info = data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    checkData(user) {
      if (user != null) {
        return user;
      }
      return "Usuário não informado";
    },

    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
